import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { ReviewPackageResolveChangesDialogComponent } from '@portal-core/reviews/review-packages/components/review-package-resolve-changes-dialog/review-package-resolve-changes-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatExpansionModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    ReviewPackageResolveChangesDialogComponent
  ],
  exports: [
    ReviewPackageResolveChangesDialogComponent
  ]
})
export class ReviewPackageResolveChangesDialogModule { }
